import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SdpLayoutsComponent } from './sdp-layouts.component';
import { SdpHeaderComponent } from './sdp-header/sdp-header.component';
import { SdpFooterComponent } from './sdp-footer/sdp-footer.component';
import { SdpSidebarComponent } from './sdp-sidebar/sdp-sidebar.component';
import { DashboardComponent as OperatorDashboard } from '../operator/dashboard/dashboard.component';
import { NewComplaintComponent } from '../operator/new-complaint/new-complaint.component';
import { ComplaintComponent } from '../operator/complaint/complaint.component';
import { DashboardComponent as OfficerDashboard } from '../officer/dashboard/dashboard.component'
import { PendingComplaintsComponent } from '../officer/pending-complaints/pending-complaints.component';
import { ResolvedComplaintsComponent } from '../officer/resolved-complaints/resolved-complaints.component';
import { SearchComplaintsComponent } from '../officer/search-complaints/search-complaints.component';
import { DashboardComponent as MCDashboard } from '../municipal-commissioner/dashboard/dashboard.component'
import { DashboardComponent as AdminDashboard } from '../admin/dashboard/dashboard.component'
import { UserManagementComponent } from '../admin/user-management/user-management.component';
import { DepManagementComponent } from '../admin/dep-management/dep-management.component';
import { EscalationMatrixComponent } from '../admin/escalation-matrix/escalation-matrix.component';
import { ZoneWordMappingComponent } from '../admin/zone-word-mapping/zone-word-mapping.component';
import { UpdateComplaintsComponent } from '../officer/update-complaints/update-complaints.component';
import { RoleComponent } from '../admin/role/role.component'
import { UserComponent } from '../admin/user/user.component'
import { HomeComponent } from '../home/home.component';
import { PreviewComponent } from '../components/preview/preview.component';
import { UserProfileComponent } from '../sdp-layouts/user-profile/user-profile.component';
import { HierarchyComponent } from '../admin/hierarchy/hierarchy.component'
import { AuthGuardService } from 'src/app/emb/service/auth-guard.service';
// import { AuthGuradService } from 'src/app/auth-gurad.service';
import { authGuard } from '../auth/auth.guard';
import { ClosedComplaintsComponent } from '../officer/closed-complaints/closed-complaints.component';
import { EscalatedComplaintsComponent } from '../officer/escalated-complaints/escalated-complaints.component';
import { TotalGrevianceComponent } from '../municipal-commissioner/total-greviance/total-greviance.component';
import { PendingsMcComponent } from '../municipal-commissioner/pendings-mc/pendings-mc.component';
import { TodayGrevianceComponent } from '../municipal-commissioner/today-greviance/today-greviance.component';
import { AccountProfileComponent } from 'src/app/portal/account-profile/account-profile.component';
const routes: Routes = [
  // {
  //   path: "", component: HomeComponent
  // },
  {
    path: "index", component: SdpLayoutsComponent
  },
  {
    path: "admin/dashboard", component: AdminDashboard,
    // canActivate: [authGuard],
// runGuardsAndResolvers:'always',
    // data: { ComponentCode: 'SDP-R2' }

  },
  {
    path: "admin/user-management", component: UserManagementComponent
  },
  {
    path: "admin/dep-management", component: DepManagementComponent
  },
  {
    path: "admin/escalation-matrix", component: EscalationMatrixComponent
  },
  {
    path: "admin/zone-word-mapping", component: ZoneWordMappingComponent
  },
  {
    path: "admin/zone-word-mapping", component: ZoneWordMappingComponent
  },
  {
    path: "admin/role", component: RoleComponent
  },


  {
    path: "admin/user", component: UserComponent
  },

  {
    path: "admin/hier", component: HierarchyComponent
  },

  {
    path: "operator/dashboard", component: OperatorDashboard,
    // canActivate: [authGuard],
    // data: { ComponentCode: 'SDP-R4' }

  },
  {
    path: "operator/new-compliants", component: NewComplaintComponent
  },
  {
    path: "operator/compliants", component: ComplaintComponent
  },
  {
    path: "complaints/preview", component: PreviewComponent
  },
  {
    path: "officer/dashboard", component: OfficerDashboard,
    // canActivate: [authGuard],

    // data: { ComponentCode: 'SDP-R3' }

  },
  {
    path: "officer/update-complaints", component: UpdateComplaintsComponent
  },
  {
    path: "officer/pending-complaints", component: PendingComplaintsComponent
  },
  {
    path: "officer/resolved-complaints", component: ResolvedComplaintsComponent
  },
  {
    path: "officer/closed-complaints", component: ClosedComplaintsComponent
  },
  {
    path: "officer/escalated-complaints", component: EscalatedComplaintsComponent
  },
  {
    path: "mc/dashboard", component: MCDashboard,
    // canActivate: [authGuard],
    // data: { ComponentCode: 'SDP-R14' }
  },
   {
    path: "mc/total-greviance", component: TotalGrevianceComponent,
    // canActivate: [authGuard],
    // data: { ComponentCode: 'SDP-R14' }
  },
    {
    path: "mc/pending-mc", component: PendingsMcComponent,

  },
     {
    path: "mc/today-greviance", component: TodayGrevianceComponent,

  },
  {
    path: "UserProfileComponent", component: UserProfileComponent
  },
   {
    path: "portal/acc", component: AccountProfileComponent
  },
  {
    path: "task", component: PendingComplaintsComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SdpLayoutsRoutingModule { }
